import React, { useState } from 'react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel';
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from '@/components/ui/dialog';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';
import { getPhotoUrl } from '@/utils/photoUrl';

export function ImageGallery({ fotos = [], className }) {
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  if (!fotos || fotos.length === 0) {
    return (
      <div className={cn("aspect-video rounded-md bg-muted flex items-center justify-center", className)}>
        <p className="text-muted-foreground">Sin fotos</p>
      </div>
    );
  }

  return (
    <>
      <Carousel className={cn("w-full", className)}>
        <CarouselContent>
          {fotos.map((foto, index) => (
            <CarouselItem key={index}>
              <div 
                className="aspect-video rounded-md overflow-hidden bg-muted cursor-pointer relative group"
                onClick={() => setSelectedImageIndex(index)}
              >
                <img
                  src={getPhotoUrl(foto)}
                  alt={`Foto ${index + 1}`}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors flex items-center justify-center">
                  <span className="text-white opacity-0 group-hover:opacity-100 transition-opacity bg-black/50 px-3 py-1.5 rounded-full text-sm font-medium">
                    Ampliar
                  </span>
                </div>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="left-4" />
        <CarouselNext className="right-4" />
      </Carousel>

      <Dialog open={selectedImageIndex !== null} onOpenChange={(open) => !open && setSelectedImageIndex(null)}>
        <DialogContent className="max-w-[95vw] sm:max-w-[80vw] h-[90vh] p-0 bg-black/95 border-none shadow-none flex flex-col justify-center items-center gap-0">
          <DialogTitle className="sr-only">Galería de Imágenes</DialogTitle>
          <button 
            onClick={() => setSelectedImageIndex(null)}
            className="absolute top-4 right-4 z-50 p-2 bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
          
          {selectedImageIndex !== null && (
            <Carousel 
              className="w-full h-full flex items-center" 
              opts={{ startIndex: selectedImageIndex, loop: true }}
            >
              <CarouselContent className="h-full">
                {fotos.map((foto, index) => (
                  <CarouselItem key={index} className="h-full flex items-center justify-center">
                    <div className="w-full h-full flex items-center justify-center overflow-hidden p-4 sm:p-12">
                      <img
                        src={getPhotoUrl(foto)}
                        alt={`Foto ${index + 1}`}
                        className="max-w-full max-h-full object-contain select-none"
                      />
                    </div>
                  </CarouselItem>
                ))}
              </CarouselContent>
              <CarouselPrevious className="left-4 sm:left-8 h-10 w-10 sm:h-12 sm:w-12 bg-white/10 text-white border-white/20 hover:bg-white/20 hover:text-white" />
              <CarouselNext className="right-4 sm:right-8 h-10 w-10 sm:h-12 sm:w-12 bg-white/10 text-white border-white/20 hover:bg-white/20 hover:text-white" />
            </Carousel>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
